import React, { useEffect, useState, useCallback } from 'react'
import { useNetworkStatus } from 'react-offix-hooks'
import { RefreshControl, Button, Text, View } from 'react-native'
import EStyleSheet from 'react-native-extended-stylesheet'
import { useHistory } from 'react-router-native'
import { useQuery } from '@apollo/react-hooks'
import { ScrollView } from 'react-native-gesture-handler'
import { useApolloOfflineClient } from 'react-offix-hooks'
import { APP_DATA } from 'graphql/queries'

import { onRefreshCall } from 'utils/navigation'
import { compareNumbers } from 'utils/calculations'
import { IS_WEB } from 'constants/static'
import MESSAGES from 'constants/messages'

import TaskListElement from './TaskListElement'

const findCompleted = (t: TaskInterface, completedList: TaskCompleteType[]) => {
  return (completedList || []).find(({ taskId }) =>
    compareNumbers(taskId, t.id),
  )
}

// click on refresh button TODO: remove
// tslint:disable-next-line no-empty
const handleRefreshPress = () => {}

// component to render the task list
export default function TaskListMapping({
  tasks,
  locationHierarchyId,
  sessionUuid,
  completedTaskEvents: completedList,
  loading,
  refetch,
  additionalPadding,
  snippetsMapping,
  showSnippets,
}: TaskListMappingPropsType) {
  const client = useApolloOfflineClient()
  // dont let errors in the connection interfere with the app, work offline
  const history = useHistory()
  // online status
  const online = useNetworkStatus()
  // state to show refreshing indicators
  const [refreshing, setRefreshing] = useState(false)
  // getter
  const getRefreshing = useCallback(() => refreshing, [refreshing])
  // on refresh
  const onRefresh = useCallback(() => {
    onRefreshCall(online, getRefreshing, setRefreshing, refetch)
  }, [refreshing, online])
  // go back
  const handleGoBack = useCallback(() => {
    history.goBack()
  }, [])
  const nextUncompletedTask = () =>
    tasks.find((task) => !findCompleted(task, completedList))

  const { data } =
    useQuery<{
      appData: AppDataType
    }>(APP_DATA)

  useEffect(() => {
    if (IS_WEB && !!tasks?.length) {
      const taskAlreadySelected = tasks.find(
        (task) => task.id === data?.appData?.taskDescriptionModalId,
      )
      if (taskAlreadySelected) {
        return
      }

      const selectedTask = nextUncompletedTask() || tasks[0]

      client.writeData({
        data: {
          appData: {
            taskDescriptionModalId: selectedTask.id,
            __typename: 'AppData',
          },
        },
      })
    }
  }, [tasks, data])

  return (
    <View style={{ flex: 1 }}>
      {!Boolean(sessionUuid) && Boolean(tasks?.length) && (
        <Button
          title={MESSAGES.START_SESSION_TO_INTERACT}
          onPress={handleGoBack}
        />
      )}
      <View
        style={additionalPadding ? styles.container : styles.containerNoPadding}
      >
        {refreshing && (
          <Button onPress={handleRefreshPress} title="refreshing..." />
        )}
        <ScrollView
          keyboardShouldPersistTaps="handled"
          style={styles.scrollViewStyle}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
        >
          {(tasks || []).map((task: TaskInterface) => {
            const completedEvent = findCompleted(task, completedList)

            return (
              <TaskListElement
                // @ts-ignore
                key={task.id}
                {...task}
                {...{
                  sessionUuid,
                  locationHierarchyId,
                  completedEvent,
                  snippetsMapping,
                  showSnippets,
                }}
              />
            )
          })}
          {!Boolean(tasks?.length) && !loading && (
            <Text>no task to execute for this date</Text>
          )}
        </ScrollView>
      </View>
    </View>
  )
}

// styles
const styles = EStyleSheet.create({
  parentContainer: {
    flex: 1,
  },
  container: {
    paddingTop: 0,
    flex: 1,
  },
  containerNoPadding: {
    paddingTop: 0,
    flex: 1,
  },
  scrollViewStyle: {
    paddingLeft: IS_WEB ? 0 : 10,
    paddingRight: IS_WEB ? 0 : 10,
    marginBottom: IS_WEB ? 0 : 10,
  },
})
